import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./PaymentReasonModal.css";

const MIN_REASON_LENGTH = 10;

// Confirmation popup with a mandatory reason field, used for CASH / WAIVE_OFF
// payment actions as well as delete-with-reason flows. `title` overrides the
// type-derived heading; the caller always owns the actual API call via onSubmit(reason).
const PaymentReasonModal = ({ open, type, title: titleProp, loading, onCancel, onSubmit }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  const [touched, setTouched] = useState(false);

  if (!open) return null;

  const trimmedReason = reason.trim();
  const error = !trimmedReason
    ? t("paymentReasonRequired")
    : trimmedReason.length < MIN_REASON_LENGTH
      ? t("paymentReasonMinLength")
      : "";
  const isValid = !error;

  const handleChange = (e) => {
    setReason(e.target.value.trimStart());
  };

  const handleSubmit = () => {
    setTouched(true);
    if (!isValid || loading) return;
    onSubmit(trimmedReason);
  };

  const handleCancel = () => {
    if (loading) return;
    onCancel();
  };

  const title = titleProp ?? (type === "CASH" ? t("collectCash") : t("waiveOff"));

  return (
    <div className="prm-overlay" onClick={handleCancel}>
      <div className="prm-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="prm-heading">{title}</h3>
        <div className="prm-field-stack">
          <label className="prm-label" htmlFor="payment-reason-textarea">
            {t("paymentReasonLabel")}
          </label>
          <textarea
            id="payment-reason-textarea"
            className="prm-textarea"
            value={reason}
            onChange={handleChange}
            onBlur={() => setTouched(true)}
            placeholder={t("paymentReasonPlaceholder")}
            rows={4}
            disabled={loading}
          />
          {touched && error && <span className="prm-error">{error}</span>}
        </div>
        <div className="prm-footer">
          <button type="button" className="prm-cancel" onClick={handleCancel} disabled={loading}>
            {t("cancel")}
          </button>
          <button type="button" className="prm-confirm" onClick={handleSubmit} disabled={loading || !isValid}>
            {loading ? t("processing") : t("submit")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentReasonModal;
